var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"nav-bar-comm-box"},[_c('nav-bar')],1),_c('div',{staticClass:"router-view-index-box"},[_c('router-view')],1),_c('div',[_c('FootBar')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }